import React from 'react'
import { Box, IcoMoon, CloseIcon } from '@usap/uicomponents'

const HowToVideo = props => {
  const {
    videoUrl,
    setShowVideo,
  } = props
  return (
    <>
      <Box id="videoHowTo" onClick={() => setShowVideo(false)}>
        <Box id="closeVideLB" style={{ textAlign: 'right', alignSelf: 'end' }}>
          <IcoMoon
            icon={CloseIcon}
            color="light-1"
            size="small"
            onClick={() => setShowVideo(false)}
            style={{
              cursor: 'pointer',
              marginBottom: '16px',
            }}
          />
        </Box>
        <iframe
          title="RMAVideo"
          width="600"
          height="338"
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </>
  )
}

export default HowToVideo
